import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { NotificationModel } from "common/models/page-models/notification/notification-data.model";

 
@Injectable()
export class EmailTemplateListDataService extends DataService<NotificationModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getTemplateList,http);
    }
    createInstance(): NotificationModel {
        return new NotificationModel();
    }
}